document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-gallery-custom__thumb-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = this.dataset.target;
      var gallery = this.closest('media-gallery');
      
      // Update active thumbnail
      gallery.querySelectorAll('.product-gallery-custom__thumb-btn').forEach(function(b) {
        b.classList.remove('is-active');
      });
      this.classList.add('is-active');
      
      // Update active main image
      gallery.querySelectorAll('.product__media-item').forEach(function(item) {
        item.classList.remove('is-active');
      });
      var activeItem = gallery.querySelector('[data-media-id="' + target + '"]');
      if (activeItem) activeItem.classList.add('is-active');
    });
  });
});